import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { craftsmanshipSections } from '../utils/mockData';
import { useSection, resolveAsset } from '../contexts/ContentContext';

const DEFAULT_FILTERS = ['zardozi', 'aari', ''];

const Craftsmanship = () => {
  const navigate = useNavigate();
  const data = useSection('home.heritage', {
    eyebrow: 'The Heritage',
    title: 'Our Pillars of Excellence',
    description: 'Each creation is a testament to centuries of artistry, passed down through generations of master craftsmen',
    cards: craftsmanshipSections,
  });
  const cards = (data.cards && data.cards.length ? data.cards : craftsmanshipSections).map((c, i) => ({
    ...c,
    id: c.id ?? i,
    image: resolveAsset(c.image),
    filter: (c.filter ?? DEFAULT_FILTERS[i] ?? '').trim(),
  }));

  const openPillar = () => {
    // All pillars surface the complete Heritage Couture collection. The
    // pillar's poetic theme is the headline — the customer should land on
    // the full range, not a substring-filtered subset of two pieces.
    navigate('/archive?type=archive');
  };

  return (
    <section id="craftsmanship" className="section-padding pillars-section">
      <div className="luxury-container">
        <div className="pillars-header">
          <p className="pillars-eyebrow">{data.eyebrow}</p>
          <h2 className="heading-1">{data.title}</h2>
          <span className="pillars-divider" aria-hidden="true">✦</span>
          <p className="body-large pillars-description">
            {data.description}
          </p>
        </div>

        <div className="pillars-grid">
          {cards.map((card, i) => (
            <button
              key={card.id ?? i}
              type="button"
              className="pillar-card"
              onClick={openPillar}
              data-testid={`pillar-${i}`}
              aria-label={`Explore ${card.title}`}
            >
              <div className="pillar-card__media">
                <img src={card.image} alt={card.title} loading="lazy" />
              </div>

              <div className="pillar-card__body">
                <p className="pillar-card__eyebrow">{card.subtitle}</p>
                <h3 className="pillar-card__title">{card.title}</h3>
                <p className="pillar-card__description">{card.description}</p>
                <span className="pillar-card__cta">
                  Explore Our Range <ArrowRight size={14} strokeWidth={1.5} />
                </span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Craftsmanship;
